/*
 * @Description: 
 * @Version: 2.0
 * @Autor: YGQ
 * @Date: 2023-05-10 15:23:04
 * @LastEditors: YGQ
 * @LastEditTime: 2023-09-22 11:46:46
 */
import { ElMessage } from 'element-plus'

// options 表示 为可选配置项
async function msg (message, type = 'info', options = { grouping: false }) {
  ElMessage({ message, type, ...options })
}

const install = (app, options) => {
  app.config.globalProperties.$msg = msg
};

export default {
  install,
};